import React from "react";
import LocationSelection from "./LocationSelection";

function LocationPopupHead({
  platform,
  setCity,
  cityLocation,
  setClearButton,
  onClear,
  setFocus,
  onCityRemove,
  onAreaRemove,
  citiesWithArea,
  isActive,
  gaTrackingLabel,
  handleAreaSelection,
}) {
  return (
    <LocationSelection
      platform={platform}
      setCity={setCity}
      cityLocation={cityLocation}
      setClearButton={setClearButton}
      onClear={onClear}
      setFocus={setFocus}
      setArea={handleAreaSelection}
      onCityRemove={onCityRemove}
      onAreaRemove={onAreaRemove}
      citiesWithArea={citiesWithArea}
      isActive={isActive}
      gaTrackingLabel={gaTrackingLabel}
    />
  );
}

export default LocationPopupHead;
